import { moment } from '../../dependencies';
import { DatePickerInput, TimePickerInput } from '../Inputs/PickerInput';
import wrapWithField from '../../HOC/wrapWithField';
var DatePickerField = wrapWithField(DatePickerInput, {
  normalize: function normalize(value) {
    return moment(value).toISOString();
  }
});
var TimePickerField = wrapWithField(TimePickerInput, {
  normalize: function normalize(value) {
    return moment(value).toISOString();
  }
});
export { DatePickerField, TimePickerField };